"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.convertStunUrlToTurn = convertStunUrlToTurn;
exports.convertStunUrlToTurnTls = convertStunUrlToTurnTls;
/* eslint-disable import/prefer-default-export */
/**
 * Converts a stun url to a turn url
 *
 * @param {string} stunUrl url of a stun server
 * @param {'tcp'|'udp'} protocol what protocol to use for the turn server
 * @returns {string} url of a turn server
 */
function convertStunUrlToTurn(stunUrl, protocol) {
  // stunUrl looks like this: "stun:external-media91.public.wjfkm-a-10.prod.infra.webex.com:5004"
  // and we need it to be like this: "turn:external-media91.public.wjfkm-a-10.prod.infra.webex.com:5004?transport=tcp"
  var url = new URL(stunUrl);
  if (url.protocol !== 'stun:') {
    throw new Error("Not a STUN URL: ".concat(stunUrl));
  }
  url.protocol = 'turn:';
  if (protocol === 'tcp') {
    url.searchParams.append('transport', 'tcp');
  }
  return url.toString();
}

/**
 * Converts a stun url to a turns url
 *
 * @param {string} stunUrl url of a stun server
 * @returns {string} url of a turns server
 */
function convertStunUrlToTurnTls(stunUrl) {
  // stunUrl looks like this: "stun:external-media1.public.wjfkm-a-15.prod.infra.webex.com:443"
  // and we need it to be like this: "turns:external-media1.public.wjfkm-a-15.prod.infra.webex.com:443?transport=tcp"
  var url = new URL(stunUrl);
  if (url.protocol !== 'stun:') {
    throw new Error("Not a STUN URL: ".concat(stunUrl));
  }
  url.protocol = 'turns:';
  url.searchParams.append('transport', 'tcp');
  return url.toString();
}
//# sourceMappingURL=util.js.map
